import { render } from "./Notificacionesdropdown.vue?vue&type=template&id=73515722&scoped=true"
import script from "./Notificacionesdropdown.vue?vue&type=script&lang=js"
export * from "./Notificacionesdropdown.vue?vue&type=script&lang=js"

import "./Notificacionesdropdown.vue?vue&type=style&index=0&id=73515722&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73515722"]])

export default __exports__